<div class="row">
  <div class="col-12">
    <div class="card card-body">
      <div class="header">
        <h4 class="card-title mb-0">
          <span class="lstick"></span>Express shipping List
        </h4>

        <div class="d-flex">
          <a href="javascript: void(0);" class="btn btn-primary" placement="top"
            (click)="openModal(editModal, {}, 'Add Shipping')" ngbTooltip="Add Shipping">
            + Add Shipping
          </a>
        </div>
      </div>

      <table class="table table-striped border mt-4">
        <thead class="table-light">
          <tr>
            <th scope="col">Service Name</th>
            <th scope="col">Price</th>
            <th scope="col">Vat</th>
            <th scope="col">Is Exclusive</th>
            <th scope="col">Country</th>
            <!-- <th scope="col">Store</th> -->
            <th scope="col">Created At</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let shipping of shippingData; let i = index">
            <td>
              <div class="d-flex flex-column">
                <span class="font-weight-bold">{{
                  shipping?.serviceName
                  }}</span>
                <small class="text-muted">{{
                  shipping?.country_iso_code
                  }}</small>
              </div>
            </td>
            <td>
              {{ shipping?.countryObject?.currency }}
              {{ shipping?.price }}
            </td>
            <td>{{ shipping?.vat ? shipping.vat + "%" : "" }}</td>
            <td>
              <span class="badge" style="font-size: 12px" [ngClass]="
                  shipping?.isExclusive ? 'badge-success' : 'badge-secondary'
                ">
                {{ shipping?.isExclusive ? "Yes" : "No" }}
              </span>
            </td>

            <td>{{ shipping?.countryObject?.iso }}</td>
            <td>{{ shipping.created_at | date : "medium" }}</td>
            <td>
              <button class="btn btn-sm btn-primary mr-1" (click)="openModal(editModal, shipping, 'Edit Shipping')"
                ngbTooltip="Edit Shipping">
                <i class="fa fa-edit"></i>
              </button>
              <button class="btn btn-sm btn-danger ms-1" (click)="openDeleteModal(deleteModal, shipping._id)"
                ngbTooltip="Delete">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>

          <tr *ngIf="shippingData?.length === 0 && !loading">
            <td colspan="7" class="text-center text-muted">
              No shipping records found.
            </td>
          </tr>
        </tbody>
      </table>

      <div class="d-flex justify-content-center mt-5" *ngIf="shippingData?.length != 0">
        <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="totalCount" [maxSize]="7"
          [rotate]="true" [ellipses]="false" [boundaryLinks]="true" (pageChange)="loadPage($event)"></ngb-pagination>
      </div>
    </div>
  </div>
</div>
<ng-template #editModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ modeltitle }}</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="shippingForm" (ngSubmit)="onSubmit()">
      <div class="form-group mb-3">
        <label for="serviceName">Service Name</label>
        <input type="text" id="serviceName" class="form-control" formControlName="serviceName"
          placeholder="Enter Service Name" [ngClass]="{
            'is-invalid':
              shippingForm.get('serviceName')?.touched &&
              shippingForm.get('serviceName')?.invalid
          }" />
        <div class="invalid-feedback">Service Name is required</div>
      </div>

      <div class="form-group mb-3">
        <label for="country_iso_code">Country</label>
        <select id="country_iso_code" class="form-control" formControlName="country_iso_code" [ngClass]="{
            'is-invalid':
              shippingForm.get('country_iso_code')?.touched &&
              shippingForm.get('country_iso_code')?.invalid
          }">
          <option value="" disabled>Select Country</option>
          <option *ngFor="let c of allcountry" [value]="c.alpha2Code">
            {{ c.name }} ({{ c.alpha2Code }})
          </option>
        </select>
        <div class="invalid-feedback">Country is required</div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="price">Price</label>
            <input type="number" id="price" class="form-control" formControlName="price" placeholder="0.00" min="0"
              [ngClass]="{
                'is-invalid':
                  shippingForm.get('price')?.touched &&
                  shippingForm.get('price')?.invalid
              }" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="vat">VAT (%)</label>
            <input type="number" id="vat" class="form-control" formControlName="vat" min="0" placeholder="0" [ngClass]="{
                'is-invalid':
                  shippingForm.get('vat')?.touched &&
                  shippingForm.get('vat')?.invalid
              }" />
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center mb-3">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="isExclusive" formControlName="isExclusive" />
          <label class="form-check-label" for="isExclusive">Is Exclusive</label>
        </div>
      </div>

      <div class="modal-footer px-0 pb-0">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Close click')">
          Close
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="submitting">
          <span *ngIf="submitting" class="spinner-border spinner-border-sm me-1"></span>
          {{ modeltitle === "Add Shipping" ? "Add" : "Update" }}
        </button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #deleteModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Delete Shipping</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to delete this shipping service?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Close click')">
      Cancel
    </button>
    <button type="button" class="btn btn-danger" (click)="confirmDelete()">
      Delete
    </button>
  </div>
</ng-template>